export default __webpack_public_path__ + "static/media/greenTick2.310d93b2.png";